/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Groupsmemberremoved2Inputs */

const en_groupsmemberremoved2 = /** @type {(inputs: Groupsmemberremoved2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is no longer in the group.`)
};

const de_groupsmemberremoved2 = /** @type {(inputs: Groupsmemberremoved2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ist nicht mehr in der Gruppe.`)
};

/**
* | output |
* | --- |
* | "{name} is no longer in the group." |
*
* @param {Groupsmemberremoved2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsmemberremoved2 = /** @type {((inputs: Groupsmemberremoved2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsmemberremoved2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsmemberremoved2(inputs)
	return de_groupsmemberremoved2(inputs)
});
export { groupsmemberremoved2 as "groupsMemberRemoved" }